import {
  EtiquetaDePagina,
  CLASE_TITULO_DE_PAGINA,
  CLASE_SUBTITULO_DE_PAGINA,
} from '@/components/patterns';
import { BookOpen, Rocket, HelpCircle, Shield } from 'lucide-react';
import { AppLayout } from '@/components/layout/app-layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { FadeIn } from '@/components/motion';
import { ManualChapterViewer } from '../components/manual-chapter-viewer';
import { QuickStartGuide } from '../components/quick-start-guide';
import { FaqSection } from '../components/faq-section';
import { SlaSection } from '../components/sla-section';

export function HelpCenterPage() {
  return (
    <AppLayout>
      <div className="mx-auto max-w-6xl space-y-6 p-4 sm:p-6">
        {/* Header */}
        <FadeIn direction="up">
          <div>
            <div className="mb-3">
              <EtiquetaDePagina tono="neutro">Ayuda</EtiquetaDePagina>
            </div>
            <h1 className={CLASE_TITULO_DE_PAGINA}>Centro de Ayuda</h1>
            <p className={`mt-2 ${CLASE_SUBTITULO_DE_PAGINA}`}>
              Todo lo que necesitás para usar Prixia
            </p>
          </div>
        </FadeIn>

        {/* Tabs */}
        <FadeIn direction="up" delay={0.1}>
          <Tabs defaultValue="manual">
            <TabsList className="w-full justify-start overflow-x-auto">
              <TabsTrigger value="manual" className="gap-1.5">
                <BookOpen className="h-4 w-4" />
                <span className="hidden sm:inline">Manual</span>
              </TabsTrigger>
              <TabsTrigger value="quick-start" className="gap-1.5">
                <Rocket className="h-4 w-4" />
                <span className="hidden sm:inline">Inicio rápido</span>
              </TabsTrigger>
              <TabsTrigger value="faq" className="gap-1.5">
                <HelpCircle className="h-4 w-4" />
                <span className="hidden sm:inline">Preguntas frecuentes</span>
              </TabsTrigger>
              <TabsTrigger value="sla" className="gap-1.5">
                <Shield className="h-4 w-4" />
                <span className="hidden sm:inline">SLA</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="manual" className="mt-6">
              <ManualChapterViewer />
            </TabsContent>

            <TabsContent value="quick-start" className="mt-6">
              <QuickStartGuide />
            </TabsContent>

            <TabsContent value="faq" className="mt-6">
              <FaqSection />
            </TabsContent>

            <TabsContent value="sla" className="mt-6">
              <SlaSection />
            </TabsContent>
          </Tabs>
        </FadeIn>
      </div>
    </AppLayout>
  );
}
